import { Component } from '@angular/core';
import { WithDatasourceComponent } from './with-datasource.component';
import { PartTimeTypeValue } from 'app/rm/erp/employment/model/employment-values';

@Component( {
    selector: 'erp-pbw-tz-art',
    templateUrl: './with-datasource.component.html'
} )
export class PartTimeTypeFormComponent extends WithDatasourceComponent<PartTimeTypeValue>   {

    constructor() {
        super(
            {
                datasourceName: 'api/v1/rm/erp/employment/value/employmentparttimetype',
                fieldDisplayName: 'text',
                i18nIdentifier: 'rm.erp.jobapplication.JobApplication.partTimeType',
            } );
    }

    set value( t: PartTimeTypeValue | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.partTimeType = t;
        }
    }

    get value(): PartTimeTypeValue | undefined {
        return this.jobapplication?.partTimeType;
    }

    getFieldValue( t?: PartTimeTypeValue ): string | undefined {
        return t?.text;
    }
}
